module.exports = __webpack_public_path__ + "img/rank-teacher-pic002.933c2b16.png";